module.exports = __webpack_public_path__ + "img/status_success_black-01.55e6f16c.png";